export interface Route {
    path: string;
    [key: string]: any;
}

export const pathJoin = (prefix: string, path: string) => {
    if (prefix.endsWith("/") && path.startsWith("/")) {
        return prefix + path.substring(1);
    } else if (!prefix.endsWith("/") && !path.startsWith("/")) {
        return prefix + "/" + path;
    }
    return prefix + path;
};

export const pathPrefixManipulator = (prefix: string) => {
    return (route: Route) => {
        return { ...route, path: pathJoin(prefix, route.path) };
    };
}